import { NewTooltip } from '@lib/components'
import { UserFriends } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import css from './styles.module.css'

interface Props {
  email: string | null
}

export const SharedMarker: React.FC<Props> = ({ email }) => {
  if (!email) {
    return null
  }
  return (
    <NewTooltip
      content={<span className={css.tooltip_content}>Shared by {email}</span>}
      renderEl={(onSetRef, onMouseEnter, onMouseLeave) => (
        <div
          ref={onSetRef}
          className={css.icon_wrap}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          <UserFriends />
        </div>
      )}
    />
  )
}
